var map = {
	"./en/adminPage": 20415,
	"./es/adminPage": 41320,
	"./fr/adminPage": 83372,
	"./hn/adminPage": 78742,
	"./pb/adminPage": 93514,
	"./rs/adminPage": 25667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91482;